module.exports = __webpack_public_path__ + "img/feature-solar-storage.4fdb7796.jpg";